import { useErrorOverlayStore } from "../stores/error-overlay-store"
import { isChunkLoadError } from "./lazy-retry"

export function installGlobalErrorHandlers() {
  window.addEventListener("error", (event: ErrorEvent) => {
    // Ignore errors from browser extensions or cross-origin scripts
    if (!event.filename || event.filename.includes("extension://")) return

    const fileLocation =
      event.filename && event.lineno
        ? `${event.filename.split("/").pop()}:${event.lineno}${event.colno ? `:${event.colno}` : ""}`
        : undefined

    useErrorOverlayStore.getState().addError({
      message: event.message || "Unknown error",
      source: "runtime",
      stack: event.error?.stack,
      fileLocation,
    })
  })

  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const error = event.reason
    if (error instanceof Error && isChunkLoadError(error)) return
    const message =
      error instanceof Error
        ? error.message
        : typeof error === "string"
          ? error
          : "Unhandled promise rejection"
    const stack = error instanceof Error ? error.stack : undefined

    useErrorOverlayStore.getState().addError({
      message,
      source: "promise",
      stack,
    })
  })
}
